import {
  SELECT_CONNECTION_FOR_TRIAL_BALANCE_THRESHOLD,
  FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_SUCCESS,
} from './types';

const initialState = {
  connectionName: null,
  connectionNames: [],
};

function trialBalanceThreshold(state = initialState, action) {
  switch (action.type) {
    case SELECT_CONNECTION_FOR_TRIAL_BALANCE_THRESHOLD:
      return {
        ...state,
        connectionName: action.connectionName,
      };
    case FETCH_CONNECTIONS_FOR_TRIAL_BALANCE_THRESHOLD_SUCCESS:
      return {
        ...state,
        connectionNames: action.connectionNames,
        connectionName: action.connectionName,
      };
    default:
      return state;
  }
}

export default trialBalanceThreshold;
